export default "__VITE_ASSET__CyYSUn1$__"